<template>
    <div>
        <template v-if="getExtras().length">
            <table cellpadding="0" cellspacing="0" border="0" style="background-color: #eee; width: 100%; font-size: 14px; font-weight: 600">
                <tr>
                    <td style="text-align: left; padding: 10px; font-weight: 600">
                        {{ $t('plan_calculator.extras') }}
                    </td>
                    <td style="text-align: right; padding: 10px;">
                        <pm-price style="font-size: 12px; font-weight: 600;" :currency="$store.state.currency" :value="fullTotal" />
                    </td>
                </tr>
            </table>

            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; font-size: 12px; font-weight: 600">
                <tr v-for="(option, key) in getExtras()" v-if="option.amount > 0">
                    <template v-if="option.isPercentage">
                        <td style="border-top: 1px dotted #eee; text-align: left; padding: 10px; font-size: 12px; font-weight: 600">
                            {{ getTitle(option) }} (+{{ option.amount }}%)
                        </td>
                        <td style="border-top: 1px dotted #eee; text-align: right; padding: 10px;">
                            <pm-price style="font-size: 12px; color: #444;" :value="Math.round(($store.state.simplePlan.upperJawTotal + $store.state.simplePlan.lowerJawTotal) * (option.amount / 100))" />
                        </td>
                    </template>

                    <template v-else>
                        <td style="border-top: 1px dotted #eee; text-align: left; padding: 10px; font-size: 12px; font-weight: 600">
                            <span v-if="!option.isPercentage">{{ option.amount }}</span> {{ getTitle(option) }}
                            <!-- <template v-if="typeof option.toothIds !== 'undefined' && option.toothIds.length > 0">
                                ({{option.toothIds.map(el => Helper.getToothNotation(el)).join(", ")}})
                            </template> -->
                        </td>
                        <td style="border-top: 1px dotted #eee; text-align: right; padding: 10px;">
                            <pm-price style="font-size: 12px; color: #444;" :value="option.unit_price * option.amount" />
                        </td>
                    </template>
                </tr>
            </table>
        </template>
    </div>
</template>

<script>
    import PmExtrasOverview from "./extras-overview";
    export default {
        extends: PmExtrasOverview,
    }
</script>
